import { useEffect, useState } from "react";
import { api, API_BASE } from "@/lib/api";
import { rupiah, todayISO } from "@/lib/format";
import { PageHeader } from "@/components/app/Layout";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Download, FileSpreadsheet } from "lucide-react";

const downloadFile = async (path, params, filename) => {
  const token = localStorage.getItem("khn_token");
  const url = new URL(`${API_BASE}${path}`);
  Object.entries(params).forEach(([k, v]) => v && url.searchParams.set(k, v));
  const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
  const blob = await res.blob();
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob); a.download = filename; a.click();
};

export default function Neraca() {
  const [sampai, setSampai] = useState(todayISO());
  const [d, setD] = useState(null);
  useEffect(()=>{ api.get("/laporan/neraca",{params:{sampai}}).then(r=>setD(r.data)); },[sampai]);
  if(!d) return null;
  return (<>
    <PageHeader title="Neraca" subtitle={`Per ${sampai}`}
      actions={<>
        <Button variant="outline" onClick={()=>downloadFile("/laporan/neraca/export",{fmt:"pdf",sampai},`neraca-${sampai}.pdf`)} className="rounded-sm" data-testid="neraca-dl-pdf"><Download size={14} className="mr-1"/> PDF</Button>
        <Button variant="outline" onClick={()=>downloadFile("/laporan/neraca/export",{fmt:"xlsx",sampai},`neraca-${sampai}.xlsx`)} className="rounded-sm" data-testid="neraca-dl-xlsx"><FileSpreadsheet size={14} className="mr-1"/> Excel</Button>
      </>}/>
    <div className="p-4 md:p-8 space-y-6">
      <div className="card-flat p-4 max-w-xs"><Label>Sampai Tanggal</Label><Input type="date" value={sampai} onChange={(e)=>setSampai(e.target.value)}/></div>
      <div className="grid md:grid-cols-2 gap-5">
        <div className="card-flat">
          <div className="px-5 py-3 border-b bg-blue-50 font-semibold brand-text">ASET</div>
          <table className="w-full text-sm">
            <tbody>
              {d.aset.map(a=>(<tr key={a.nama} className="border-b"><td className="p-3 pl-6">{a.nama}</td><td className="p-3 text-right font-mono">{rupiah(a.jumlah)}</td></tr>))}
              <tr className="font-bold bg-blue-100"><td className="p-3">Total Aset</td><td className="p-3 text-right font-mono brand-text">{rupiah(d.total_aset)}</td></tr>
            </tbody>
          </table>
        </div>
        <div className="card-flat">
          <div className="px-5 py-3 border-b bg-amber-50 font-semibold text-amber-800">KEWAJIBAN & EKUITAS</div>
          <table className="w-full text-sm">
            <tbody>
              {d.kewajiban.map(k=>(<tr key={k.nama} className="border-b"><td className="p-3 pl-6">{k.nama}</td><td className="p-3 text-right font-mono">{rupiah(k.jumlah)}</td></tr>))}
              <tr className="border-b bg-amber-50 font-semibold"><td className="p-3">Total Kewajiban</td><td className="p-3 text-right font-mono">{rupiah(d.total_kewajiban)}</td></tr>
              {d.ekuitas.map(e=>(<tr key={e.nama} className="border-b"><td className="p-3 pl-6">{e.nama}</td><td className="p-3 text-right font-mono">{rupiah(e.jumlah)}</td></tr>))}
              {d.rincian_laba_ditahan?.ada_pembagian && (<>
                <tr className="border-b text-xs text-slate-500"><td className="p-3 pl-10">↳ Laba ditahan ditetapkan (dari pembagian dividen)</td><td className="p-3 text-right font-mono">{rupiah(d.rincian_laba_ditahan.laba_ditahan_ditetapkan)}</td></tr>
                <tr className="border-b text-xs text-slate-500"><td className="p-3 pl-10">↳ Dividen dibagikan (kumulatif)</td><td className="p-3 text-right font-mono">{rupiah(d.rincian_laba_ditahan.dividen_dibagikan_kumulatif)}</td></tr>
              </>)}
              <tr className="font-bold bg-emerald-100"><td className="p-3">Total Kewajiban + Ekuitas</td><td className="p-3 text-right font-mono">{rupiah(d.total_kewajiban+d.total_ekuitas)}</td></tr>
            </tbody>
          </table>
        </div>
      </div>
      <p className="text-xs text-slate-500">*Neraca sederhana basis kas. Untuk akuntansi akrual penuh (Chart of Accounts, jurnal double-entry, aktiva tetap & penyusutan) diperlukan pengembangan lanjutan.</p>
    </div>
  </>);
}
